@defer {
    <p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
    <div
        *ngIf="isLoading()"
        style=" position: fixed; top: 0; left: 0; width: 100%;height: 100%; background-color: rgba(0, 0, 0, 0.4);display: flex; align-items: center; justify-content: center; z-index: 9999;">
        <p-progressSpinner
            styleClass="w-4rem h-4rem"
            strokeWidth="4"
            animationDuration=".5s"/>
    </div>
    <div class="{{cardStyle?cardStyle:'card border-round'}}">
        <p-progressSpinner
            *ngIf="this.isLoadingPds()"
            styleClass="w-4rem h-4rem"
            strokeWidth="4"
            animationDuration=".5s"/>
        <div class="col-12 p-0">
            <div class="p=0" *ngIf="!this.isLoadingPds()">
                <div class="flex align-items-center p-1"
                     *ngIf="Array.isArray(this.pds.itemsPorEstado()) && this.pds.itemsPorEstado().length>0">
                    <p-avatar icon="pi pi-filter" size="normal" shape="circle"
                              styleClass="text-base bg-indigo-100 text-indigo-700"></p-avatar>
                    <span class="text-xl">
                    {{ titulo ? titulo : '(' + this.pds.itemsPorEstado().length + ') resultados' }}
                </span>
                </div>
                <div class="flex align-items-center p-1"
                     *ngIf="!Array.isArray(this.pds.itemsPorEstado()) || this.pds.itemsPorEstado().length===0">
                    <p-messages severity="warn">
                        <ng-template pTemplate>
                            <div class="text-xl p-0">
                                No se encontraron datos. Prueba con otro parámetro o rango de fechas <span
                                class="pi pi-calendar font-bold text-2xl"></span>
                            </div>
                        </ng-template>
                    </p-messages>
                </div>
            </div>
            <div class="col-12 p-0">
                <p-table columnResizeMode="expand" [value]="this.pds.itemsPorEstado()" [paginator]="true"
                         [selection]="selectedProyectos()"
                         (selectionChange)="selectedProyectos.set($event)"
                         styleClass="p-datatable-gridlines p-datatable-sm" [rows]="50" [showCurrentPageReport]="true"
                         responsiveLayout="stack" [tableStyle]="{ 'min-width': '50rem' }"
                         currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} proyectos"
                         [rowsPerPageOptions]="[25, 50,100,200]" #ProyectosTable
                         [globalFilterFields]="['sector','nombre', 'numeroExpediente', 'descripcion', 'proyectoEstado', 'idProyecto','idSolicitudTipo','tipoProyecto','solicitudTipo','cliente.nombreCompleto','cliente.telefono','cliente.usuario','estadoSolicitud','evaluaciones', 'idSolicitudEstado']">
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between flex-wrap">
                            <div class="p-toolbar-group-start"
                                 *ngIf="mostrarFiltros!=false || mostrarFiltros==undefined">
                            <span class="p-input-icon-left p-0">
                                <i class="pi pi-search"></i>
                                <input #busquedaTabla pInputText type="text"
                                       (input)="ProyectosTable.filterGlobal(busquedaTabla.value, 'contains')"
                                       placeholder="Buscar solicitudes"/>
                            </span>
                                <app-date-filter/>
                                <p-dropdown
                                    [options]="opcionesFiltroTramites"
                                    [(ngModel)]="selectedFiltroTramites"
                                    optionLabel="label"
                                    placeholder="Filtrar trámites"
                                    [tooltip]="'Esta opción te permite filtrar rápidamente las solicitudes que poseen o no poseen trámites'"
                                    (onChange)="onFiltroTramitesChange()"
                                    class="ml-2">
                                </p-dropdown>
                                <button pButton label="Limpiar búsqueda" class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        (click)="clear(ProyectosTable)"></button>
                            </div>
                            <div class="p-toolbar-group-end">
                            <span class="p-2" *ngIf="ocultarBotonNuevo!=true || ocultarBotonNuevo==undefined">
                                <p-button [routerLink]="['/users/proyectos/nuevo_proyecto/']"
                                          [queryParams]="{sessionId: sessionId}" [state]="{ forceReload: true }"
                                          label="Nuevo proyecto" queryParamsHandling="merge" icon="pi pi-plus text-2xl"
                                          styleClass="p-button-rounded p-button-info"/>
                            </span>
                                <!-- Boton solicitud_cancelar, realizar cambios -->
                                <span class="p-0" [pTooltip]="selectedCount() === 0 ? tooltipTemplate : undefined" tooltipPosition="top" style="display: inline-block;">
                                    <p-button (onClick)="openObservaciones.set(true)"
                                              *ngIf="isRolCliente() && !isAtencionCliente()"
                                              [disabled]="selectedCount() < 1 || !puedeCancelar()"
                                              label="Cancelar Solicitud" queryParamsHandling="merge"
                                              icon="pi pi-times text-2xl"
                                              styleClass="p-button-rounded p-button-secondary border-1"/>
                                            <ng-template #tooltipTemplate>
                                              <div class="flex flex-column align-items-center text-center">
                                                <img src="assets/demo/images/logos/tooltip-img-cancelar.jpg" alt="icono" style="width: 135px; height: 65px; margin-bottom: 8px;" />
                                                  <span>Seleccionar una o más solicitudes con estado Pendiente y sin pago de trámites realizados para habilitar la opción de cancelación</span>
                                              </div>
                                            </ng-template>
                                </span>
                                <span class="p-2">
                                <p-button
                                    *ngIf="this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro()"
                                    label="Registrar carnet" icon="pi pi-id-card text-2xl"
                                    styleClass="p-button-info p-button-rounded ml-2"
                                    pTooltip="Con esta opción puedes registrar un nuevo carnet que no se encuentre en la base de datos migrada."
                                    (click)="this.rpService._openDlg.set(true)"/>
                            </span>
                                <!-- Texto de Observaciones -->
                                <p-dialog [(visible)]="openObservaciones" (onHide)="hiddeDialog()" [modal]="true"
                                          [style]="{ 'top': '4vh', 'width': '50vw', 'max-width': '100rem', 'height': 'auto' }"
                                          [closable]="true" [resizable]="false" [draggable]="false" [breakpoints]="{
                                '1200px': '60vw',
                                '992px': '75vw',
                                '768px': '90vw',
                                '576px': '95vw'
                            }">
                                    <ng-template pTemplate="header">
                                        <div class="inline-flex align-items-center justify-content-center gap-2">
                                            <i class="pi pi-tags text-orange-500 text-2xl"></i>
                                            <span class="white-space-nowrap text-xl">
                                        CANCELAR SOLICITUD
                                    </span>
                                        </div>
                                    </ng-template>

                                    <div class="grid">
                                        <!-- Columna izquierda con scroll solo en pantallas medianas y grandes -->
                                        <div class="col-12 md:col-5">
                                            <div class="text-900 font-semibold mb-4">Solicitudes a cancelar
                                                ({{ selectedCount() }})
                                            </div>
                                            <div style="max-height: 25vh; overflow-y: auto;">
                                                <div *ngFor="let proyecto of selectedProyectos()"
                                                     class="flex align-items-center gap-2 mb-2">
                                                    <i class="pi pi-check-circle text-red-400 text-lg"></i>
                                                    <div class="flex flex-column">
                                                        <span>Número de expediente</span>
                                                        <span
                                                            class="text-900 font-bold">{{ proyecto.numeroExpediente }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 md:col-7">
                                            <div class="text-900 font-semibold mb-3">Detalle de cancelación</div>
                                            <app-editor-observaciones [observaciones]="observaciones()"
                                                                      (observacionesChange)="observacionesTexto($event)"></app-editor-observaciones>
                                        </div>
                                    </div>

                                    <ng-template pTemplate="footer">
                                        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-text"
                                                  (onClick)="openObservaciones.set(false)"></p-button>
                                        <p-button label="Procesar Cancelacion" icon="pi pi-check"
                                                  styleClass="mr-2 p-button-text"
                                                  (onClick)="openConfirmacionCancelacion.set(true)"
                                                  [disabled]="observacionInvalida() || isLoading()"
                                                  [loading]="isLoading()"></p-button>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog
                                    [visible]="openConfirmacionCancelacion()"
                                    (onHide)="openConfirmacionCancelacion.set(false)" [modal]="true" [closable]="false"
                                    header="Confirmar Operación" [style]="{ width: '35vw' }"
                                >
                                    <div class="p-3 text-center">
                                        <i class="pi pi-exclamation-triangle text-orange-500 text-4xl mb-3"></i>
                                        <p class="text-xl text-900 font-semibold mb-2">
                                            ¿Está seguro que desea cancelar {{ selectedProyectos().length }}
                                            solicitud(es)?
                                        </p>
                                        <p class="text-600">
                                            Esta acción no se puede deshacer.
                                        </p>
                                    </div>

                                    <ng-template pTemplate="footer">
                                        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text"
                                                  (onClick)="openConfirmacionCancelacion.set(false)"/>
                                        <p-button
                                            label="Procesar Cancelación"
                                            icon="pi pi-check"
                                            styleClass="p-button-text border-1"
                                            [loading]="isLoading()"
                                            (onClick)="ejecutarCancelacion()"
                                        />
                                    </ng-template>
                                </p-dialog>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngIf="isRolCliente() && !isAtencionCliente()">
                                <p-checkbox [binary]="true" [(ngModel)]="todosSeleccionados"
                                            (onChange)="toggleSeleccionarTodos($event.checked)"></p-checkbox>
                            </th>
                            <th pSortableColumn="numeroExpediente" style="max-width:20%">Solicitud #
                                <p-sortIcon field="numeroExpediente"></p-sortIcon>
                            </th>
                            <th pSortableColumn="fechaCreacion" style="max-width:20%">Fecha
                                Creacion
                                <p-sortIcon field="fechaCreacion"></p-sortIcon>
                            </th>
                            <th pSortableColumn="sector" style="max-width:20%">Sector
                                <p-sortIcon field="sector"></p-sortIcon>
                            </th>
                            <th pSortableColumn="solicitudTipo" style="max-width:20%"> Tipo
                                solicitud
                                <p-sortIcon field="solicitudTipo"></p-sortIcon>
                            </th>
                            <th *ngIf="isRolFuncionario()" pSortableColumn="cliente.nombreCompleto"
                                style="max-width:20%"> Cliente
                                <p-sortIcon field="cliente.nombreCompleto"></p-sortIcon>
                            </th>
                            <th pSortableColumn="nombre" style="max-width:20%"> Proyecto
                                <p-sortIcon field="nombre"></p-sortIcon>
                                <p-columnFilter type="text" field="nombre" display="menu"></p-columnFilter>
                            </th>
                            <th pSortableColumn="estadoSolicitud" style="max-width:20%">
                                <div class="flex">
                                    Estado
                                    <p-sortIcon field="estadoSolicitud"/>
                                    <p-columnFilter field="estadoSolicitud" matchMode="equals" display="menu"
                                                    [showMatchModes]="false" [showOperator]="false"
                                                    [showAddButton]="false">
                                        <ng-template pTemplate="header">
                                            <div class="px-3 pt-3 pb-0">
                                                <span class="font-bold">Filtro Por Estado</span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown
                                                [ngModel]="value"
                                                [options]="estadosNombres()"
                                                optionLabel="name"
                                                optionValue="value"
                                                (onChange)="filter($event.value)"
                                                placeholder="Selecciona estado"
                                                [showClear]="true">

                                                <ng-template let-option pTemplate="item">
                                                    <span>{{ option.name }}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th style="max-width:20%">Operaciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-proyecto>
                        <tr [ngClass]="{ 'surface-200': esCancelada(proyecto) }">
                            <td *ngIf="isRolCliente() && !isAtencionCliente()">
                                <p-tableCheckbox [value]="proyecto"
                                                 [disabled]="!esSeleccionable(proyecto)"></p-tableCheckbox>
                            </td>
                            <td>
                                {{ proyecto.numeroExpediente }}
                                <span
                                    [ngClass]="{ 'flex align-items-center': esCancelada(proyecto) }"
                                    *ngIf="esCancelada(proyecto)"
                                    [pTooltip]="'Solicitud Cancelada'"
                                    style="color:red"><b>Cancelada</b>
                                <i class="pi pi-exclamation-triangle m-2" style="color: red"></i>
                            </span>
                            </td>
                            <td>
                                <div>
                                    {{ proyecto.fechaCreacion }}
                                    <p-tag *ngIf="proyecto.numeroExpediente!=null"
                                           [pTooltip]="proyecto.numeroExpediente"
                                           icon="pi pi-qrcode" inputStyle="{padding: '1rem'}" tooltipPosition="bottom"
                                           severity="info">
                                    </p-tag>
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{ proyecto.sector }}
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{ proyecto.solicitudTipo }}
                                </div>
                            </td>
                            <td *ngIf="isRolFuncionario()">
                                <div>
                                    {{ proyecto.cliente.nombreCompleto }}<br/>
                                    <i class="pi pi-phone p-1" style="font-size:1rem; color:green !important;">
                                        <p-inputMask
                                            [pTooltip]="'Celular del cliente'"
                                            styleClass="p-1 m-1"
                                            mask="(999) 9999-9999"
                                            [disabled]="true"
                                            [readonly]="true"
                                            [(ngModel)]="proyecto.cliente.telefono"
                                            placeholder="(999) 9999-9999"/>
                                    </i>
                                    <i class="pi pi-inbox p-1" style="font-size:1rem; color:green !important;">
                                        <span class="p-1" style="color:dimgray !important;"
                                              [pTooltip]="'Correo electrónico del cliente'">{{ proyecto.cliente.usuario }}</span>
                                    </i>
                                </div>
                            </td>
                            <td>
                                <b class="p-1">{{ proyecto.nombre }}</b>
                                <div>
                                    <p-tag *ngIf="proyecto.idSolicitudTipo==1" icon="pi pi-list"
                                           [style]="{ background: 'rgb(0, 128, 0)' }" inputStyle="{paddingLeft: '2rem'}"
                                           tooltipPosition="bottom" [value]="proyecto.solicitudTipo"
                                           [pTooltip]="proyecto.solicitudTipo"/>

                                    <p-tag *ngIf="proyecto.idSolicitudTipo==2" icon="pi pi-check-circle"
                                           [style]="{ background: 'rgb(255, 165, 0)' }"
                                           inputStyle="{paddingLeft: '2rem'}"
                                           tooltipPosition="bottom" [value]="proyecto.solicitudTipo"
                                           [pTooltip]="proyecto.solicitudTipo"/>
                                    <p-tag *ngIf="proyecto.idSolicitudTipo==3" icon="pi pi-check-circle"
                                           [style]="{ background: 'rgb(0, 0, 0)' }" inputStyle="{paddingLeft: '2rem'}"
                                           tooltipPosition="bottom" [value]="proyecto.solicitudTipo"
                                           [pTooltip]="proyecto.solicitudTipo"/>


                                    <p-tag icon="pi pi-home" [style]="{ background: 'rgb(134,134,134)' }"
                                           inputStyle="{paddingLeft: '2rem'}" tooltipPosition="top" styleClass="m-2"
                                           [value]="proyecto.tipoProyecto" [pTooltip]="'Tipo de proyecto'"/>

                                    <p-tag icon="pi pi-home" [style]="{ background: 'rgb(134,134,134)' }"
                                           inputStyle="{paddingLeft: '2rem'}" tooltipPosition="top"
                                           styleClass="m-2 text-small"
                                           [value]="proyecto.institucion" [pTooltip]="'Institucion'"/>
                                </div>
                                <!--                                <span class="p-1 text-small">{{ proyecto.institucion }}</span>-->
                            </td>
                            <td>{{ obtenerNombreEstado(proyecto.estadoSolicitud) }}
                            </td>
                            <td>
                        <tr>
                            <td>
                                <app-info-tramites-proyecto [idProyecto]="proyecto.idProyecto" id="infoTramitesDlg"
                                                            [cantidadTramites]="proyecto.cantidadTramites"
                                                            [selected]="proyecto"
                                                            *ngIf="proyecto.cantidadTramites!=0">
                                </app-info-tramites-proyecto>
                            </td>
                            <td *ngIf="!isRegistroProfesional(proyecto)">
                                <p-button
                                    *ngIf="ls.hasRoles(['cliente_ventanilla']) && !esCancelada(proyecto) && !isAtencionCliente()"
                                    id="btnAgregarServicio"
                                    icon="pi pi-plus-circle" [routerLink]="['/users/tramites', proyecto.idProyecto]"
                                    [queryParams]="{sessionId: sessionId}"
                                    styleClass="p-button-rounded p-button-success"
                                    pTooltip="Agregar trámites"></p-button>
                            </td>
                            <td>
                                <p-button *ngIf="!isAtencionCliente()" id="btnVerProyecto" icon="pi pi-search"
                                          [routerLink]="['/users/proyectos/ver_proyecto/', proyecto.idProyecto]"
                                          [queryParams]="{sessionId: sessionId}"
                                          styleClass="p-button-rounded p-button-secondary"
                                          pTooltip="Ir a detalles de proyecto"></p-button>
                            </td>
                            <td>
                                <p-button id="btnIrCarrito" icon="pi pi-shopping-cart"
                                          *ngIf="!esCancelada(proyecto) && !isAtencionCliente()"
                                          [routerLink]="['/users/pagos/tramites/', proyecto.idProyecto]"
                                          [queryParams]="{sessionId: sessionId}" styleClass="p-button-rounded"
                                          pTooltip="Proceder a completar"></p-button>
                            </td>


                            <!-- BOTON - GENERACION DEL CARNET -->
                            <!-- <td *ngIf="estadoSolicitudAprovado(proyecto) && isRegistroProfesional(proyecto)">
                                <p-progressSpinner *ngIf="proyecto.carnetLoading" [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>

                                <p-button
                                    *ngIf="!proyecto.carnetLoading"
                                    id="btnGenerarCartet"
                                    icon="pi pi-download"
                                    styleClass="p-button-rounded"
                                    (click)="descargarCarnetPDF(proyecto)"
                                    pTooltip="Descargar carnet PDF"></p-button>
                            </td> -->


                            <td>
                                <ng-container
                                    *ngTemplateOutlet="confirmarAsignacionTemplate; context: {$implicit: proyecto, clickEvent: onItemClicked.bind(this, proyecto,1)}"></ng-container>
                            </td>
                            <td>
                                <ng-container
                                    *ngTemplateOutlet="confirmarEditAsignacionTemplate; context: {$implicit: proyecto, clickEvent: onItemClicked.bind(this, proyecto,2)}"></ng-container>
                            </td>
                            <td>
                                <ng-container
                                    *ngIf="proyecto.estadoSolicitud=='Evaluación' || proyecto.estadoSolicitud=='Observada'">
                                    <ng-container
                                        *ngTemplateOutlet="initEvaluacion; context: {$implicit: proyecto, clickEvent: onItemClickedEvaluacion.bind(this, proyecto)}"></ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <ng-container *ngIf="this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro()">
        <app-rp-create-dlg></app-rp-create-dlg>
    </ng-container>
} @loading {
    <p-progressSpinner ariaLabel="loading"/>
}
